<!-- src/components/Paginator.svelte -->
<script>
    export let itemsPerPageOptions;
    export let totalRecords = 0;
    export let currentPage = 1;
    export let perPage = 10;
    export let onPageChange;
    export let onItemsPerPageChange;
  
    const totalPages = Math.ceil(totalRecords / perPage);
  </script>
  
  <div class="flex justify-between items-center mt-4">
    <button
      on:click={() => onPageChange(-1)}
      disabled={currentPage === 1 || totalRecords === 0}
      class="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
    >
      Anterior
    </button>
  
    <span>Página {currentPage} de {Math.ceil(totalRecords / perPage)}</span>
  
    <label for="itemsPerPage" class="block text-sm">Items por página</label>
    <select
        id="itemsPerPage" 
        bind:value={perPage}
        on:blur={(e) => onItemsPerPageChange(e.target.value)}
    >
        {#each itemsPerPageOptions as option}
            <option value={option}>{option}</option>
        {/each}
    </select>
  
    <button
      on:click={() => onPageChange(1)}
      disabled={currentPage === totalPages || totalRecords === 0}
      class="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
    >
      Siguiente
    </button>
  </div>
  